import { DataSource, RemoteSource } from '@components-common/types';
import { UseMutateFunction, useMutation, useQueryClient } from "react-query";
import { useHttpClient, useNotifications } from "../../hooks";
import {
  deleteErrorNotification,
  deleteSuccessNotification
} from "@dirootie-web/web-components-types";
import { useApiUrlBuilder } from "./use-api.hook";
import { useMemo } from "react";

export const useApiDelete = () => {
  const build = useApiUrlBuilder();
  const httpClient = useHttpClient();
  return useMemo(() => async (source: RemoteSource) => {
      const url = build(source.url, source.urlParams);
      const res = await httpClient.delete(url);
    return res.body;
    }, [build,httpClient])
}

export const useDelete = (): UseMutateFunction<any, unknown, { source: DataSource, id: string | number }, unknown> => {
  const queryClient = useQueryClient();
  const del = useApiDelete(); // Adjust the type if needed
  const userNotificationService = useNotifications();

  return useMutation(
    ({ source, id }: { source: DataSource, id: string | number }) => del(source as RemoteSource),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('source'); // Adjust the query key as needed
        userNotificationService.success(deleteSuccessNotification);
      },
      onError: (err: any) => {
        userNotificationService.error(deleteErrorNotification);
      },
    }
  ).mutateAsync;
};
